import DOMPurify from 'dompurify';

/**
 * XSS saldırılarına karşı string'i temizler
 * @param input - Temizlenecek string
 * @returns Temizlenmiş string
 */
export const sanitizeString = (input: string): string => {
  if (typeof input !== 'string') {
    return '';
  }
  
  // HTML etiketlerini kaldır ve özel karakterleri escape et
  return DOMPurify.sanitize(input, { 
    ALLOWED_TAGS: [], 
    ALLOWED_ATTR: [] 
  });
};

/**
 * HTML içeriği için güvenli sanitization
 * @param input - Temizlenecek HTML string
 * @returns Temizlenmiş HTML string
 */
export const sanitizeHTML = (input: string): string => {
  if (typeof input !== 'string') {
    return '';
  }
  
  // Sadece güvenli HTML etiketlerine izin ver
  return DOMPurify.sanitize(input, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'p', 'br'],
    ALLOWED_ATTR: []
  });
};

/**
 * JSON objesindeki tüm string değerleri sanitize eder
 * @param obj - Sanitize edilecek obje
 * @returns Sanitize edilmiş obje
 */
export const sanitizeObject = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  if (typeof obj === 'string') {
    return sanitizeString(obj);
  }
  
  if (Array.isArray(obj)) {
    return obj.map(sanitizeObject);
  }
  
  if (typeof obj === 'object') {
    const sanitized: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        sanitized[key] = sanitizeObject(obj[key]);
      }
    }
    return sanitized;
  }
  
  return obj;
};


